import { AccountCircle, ExpandLess, ExpandMore, Mic, MicOff } from '@mui/icons-material';
import { Box, Collapse, FormHelperText, Button as MuiButton, styled } from '@mui/material';
import React, { memo, useCallback, useState } from 'react';
import { useLwp } from '../../hooks/use-lwp';
import useLwpWidgetProps from '../../hooks/use-lwp-widget-props/hooks';
import { RoundButton } from '../round-button';
import { CallActionBox } from './call-styles';

const ButtonBox = styled(Box)({
  margin: '14px 13px 4px 14px',
  display: 'inline-block',
  textAlign: 'center',
  width: '50px',
  '& > button': {
    color: 'white',
    backgroundColor: 'rgb(6, 69, 95)',
    transition: '0.2s',
    width: '48px',
    height: '48px',
    '&:hover': {
      opacity: '0.8',
      transform: 'scale(1.1)',
      transition: '0.2s',
      backgroundColor: 'rgb(6, 69, 95)'
    }
  }
});

const Button = RoundButton;

const ExpandButton = styled(MuiButton)({
  padding: 0
});

const Label = styled(FormHelperText)((styles) => ({
  color: styles.theme.palette.primary.main,
  textAlign: 'center',
  userSelect: 'none',
  '&.Mui-disabled': {
    color: styles.theme.palette.action.disabled
  }
}));

function CallActions(props: any) {
  const {
    toggleMuteCall,
    phoneState: { isMuted, phoneNumber, contactName }
  } = useLwp();
  const { widgetProps } = useLwpWidgetProps();
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const handleMute = useCallback(() => {
    toggleMuteCall();
  }, [toggleMuteCall]);

  const showProfile = () => {
    const fireProfile = async () => {
      if (widgetProps && phoneNumber && widgetProps.events && widgetProps.events.onPatientProfileClick)
        widgetProps.events.onPatientProfileClick(phoneNumber);
    };
    fireProfile();
  };

  const toggleCollapsed = useCallback(() => {
    setCollapsed(!collapsed);
  }, [collapsed]);

  return (
    <div data-testid="call-action-container-div">
      <Collapse in={!collapsed}>
        <CallActionBox>
          <ButtonBox>
            <Button toggled={isMuted} onClick={handleMute}>
              {isMuted ? <MicOff /> : <Mic />}
            </Button>
            <Label>{isMuted ? 'Unmute' : 'Mute'}</Label>
          </ButtonBox>
          <ButtonBox>
            <Button disabled={contactName === undefined} onClick={showProfile}>
              <AccountCircle />
            </Button>
            <Label>Profile</Label>
          </ButtonBox>
        </CallActionBox>
      </Collapse>
      <ExpandButton fullWidth onClick={toggleCollapsed}>
        {collapsed ? <ExpandMore /> : <ExpandLess />}
      </ExpandButton>
    </div>
  );
}

export default memo(CallActions);
